import * as gfunctions from '../../../js/generalFunctions';

CCL.orderSummary = {
  autoload: [
    ['toggleCartSummaryItems', $('.items').length > 0],
    ['promoFunction', $('.promo-code-container').length > 0],
    ['enableDeliveryCheckoutButton', $('.general-onboard-delivery-title').length > 0],
    ['enableDeliveryPlaceOrderButton', $('.general-order-payment-section-title').length > 0]
  ],

  maxCouponCount: 3,

  toggleCartSummaryItems() {
    $('.items').each((index, element) => {
      $(element).click((event) => {
        event.preventDefault();
        const targetElement = $(event.target).parents('.c-order-summary').find('.summary-dropdown-wrap');
        $(targetElement).slideToggle();
        const ariaExpanded = $(event.currentTarget).attr('aria-expanded');
        if (ariaExpanded === 'false') {
          $(event.currentTarget).attr('aria-expanded', 'true');
          $(event.currentTarget).find('img').css('transform', 'rotate(180deg)');
        } else {
          $(event.currentTarget).attr('aria-expanded', 'false');
          $(event.currentTarget).find('img').css('transform', 'rotate(0deg)');
        }
      });
    });
  },

  promoFunction() {
    if (!$('.promo-applied').length) {
      $('.another-promo').hide();
      $('.promo-code').show();
    }
    $(document.body).on('click keypress', '.promo-code', (e) => {
      if (e.type === 'click' || e.keyCode === 13) {
        e.preventDefault();
        $(e.currentTarget).hide();
        $('.apply-promo').addClass('show');
        $('#promo-id').val('');
        $('.apply-promo-container').show();
        $('.another-promo').hide();
        $('.apply-promo .apply').addClass('div-disabled');
        setTimeout(() => {
          $('#promo-id').focus();
        }, 1000);
      }
    });

    $(document.body).on('click keypress', '.apply', (e) => {
      if (e.type === 'click' || e.keyCode === 13) {
        this.applyPromo(e);
      }
    });

    $('#promo-id').keyup((e) => {
      if (e.currentTarget.value.length) {
        $(e.currentTarget.form.lastElementChild).removeClass('div-disabled');
      } else {
        $('.promo-code-container .error-msg').hide();
        $(e.currentTarget.form.lastElementChild).addClass('div-disabled');
      }
    });

    $(document.body).on('click', '.remove-promo', (e) => {
      if (e.type === 'click' || e.keyCode === 13) {
        // make remove ajax call
        this.removeCoupon(e);
      }
    });

    $(document.body).on('click', '.another-promo', (e) => {
      if (e.type === 'click' || e.keyCode === 13) {
        $('.promo-code-container .error-msg').hide();
        $('#promo-id').val('');
        $('.apply-promo').addClass('show');
        $('.apply-promo-container').show();
        $('.another-promo').hide();
        $('.apply-promo .apply').addClass('div-disabled');
        setTimeout(() => {
          $('#promo-id').focus();
        }, 1000);
      }
    });
  },

  removeCoupon(e) {
    gfunctions.showLoader();
    const token = $('#checkoutCsrfToken').length ? $('#checkoutCsrfToken').data('csrf') : $('#csrfSessionToken').data('csrf');
    const voucherCode = e.currentTarget.dataset.promocode.toUpperCase();
    $.ajax({
      type: 'POST',
      url: '/shop/cart/remove/coupon',
      data: { voucherCode },
      headers: {
        CSRFToken: token
      }
    }).done((response) => {
      gfunctions.hideLoader();
      if (response.couponRemoved) {
        // Remove GC on promo removed
        CCL.checkoutGiftCard.removeAllGC();
        // Remove OBC on promo removed
        this.removeOBC(response);
        $('.js-obc-message').html(response.orderSummary.applicableOBCAmountDescription);
        $('.disable-payment-div').removeClass('disable-payment-div');
        gfunctions.updateCartSummary(response.orderSummary);
        gfunctions.updateProductSummary(response.orderSummary);
        $(`.row-${voucherCode}`).remove();
        if ($('.promo-applied').length === (this.maxCouponCount)) {
          $('.another-promo').hide();
        } else {
          $('.another-promo').show();
        }

        if (!$('.promo-applied').length) {
          $('.another-promo').hide();
          $('.promo-code').show();
          $('.promo-code').attr('aria-live', 'assertive');
          setTimeout(() => {
            $('.promo-code').addClass('ccl-ada-focus');
            $('.promo-code').focus();
          }, 2000);
        }
      } else {
        $(e.currentTarget.parentElement.parentElement.parentElement).find('.remove-error-div').html(response.message).show();
      }
      console.log('remove promo code ajax success');
    }).fail((response) => {
      gfunctions.hideLoader();
      console.log('remove promo code ajax error');
    });
  },

  removeOBC(res) {
    if ($('.apply-obc-credit').hasClass('remove')) {
      $('.apply-obc-credit').addClass('btn-outline-black');
      $('.apply-obc-credit').removeClass('btn-link');
      $('.apply-obc-credit').removeClass('remove');
      $('.apply-obc-credit').html('Apply');
      $('.apply-obc-credit').attr('aria-label', 'Apply onboard credit');
      $('.obc-summary-container').addClass('d-none');
      const obcBeforeApplyMessage = $('#obcBeforeApplyMessage')[0].dataset.value;
      $('.onboard-credit-body .collapse-header div').html(obcBeforeApplyMessage);
      $('.btn.placeOrder').attr('disabled', 'disabled');
    }
  },

  applyPromo(e) {
    const token = $('#checkoutCsrfToken').length ? $('#checkoutCsrfToken').data('csrf') : $('#csrfSessionToken').data('csrf');
    const voucherCode = $(e.currentTarget.parentElement).find('#promo-id').val().toUpperCase();
    gfunctions.showLoader();
    $.ajax({
      type: 'POST',
      url: '/shop/cart/apply/coupon',
      data: { voucherCode },
      headers: {
        CSRFToken: token
      }
    }).done((response) => {
      gfunctions.hideLoader();
      if (response.couponApplied) {
        // remove GC on promo applied
        CCL.checkoutGiftCard.removeAllGC();

        // Remove OBC on promo applied
        this.removeOBC(response);

        $('.js-obc-message').html(response.orderSummary.applicableOBCAmountDescription);

        $('.apply-promo-container').hide();
        if (response.couponAmount) {
          response.couponAmount = response.couponAmount.toFixed(2);
          $('.promo-added').append(
            `<div class="promo-applied row-${voucherCode}">
            <div class="inner-promo-applied">
              <div class="show-promo">PROMO:<span class="promo-code-text" aria-live="assertive" role="alert" aria-label="promo ${voucherCode} applied">${voucherCode}</span>
              <a href="#" class="remove-promo" aria-label="remove applied promo ${voucherCode}" data-promocode="${voucherCode}">Remove</a>
              </div>
              <div class="discount">-$${response.couponAmount}</div>
            </div>
            <div class="remove-error-div"></div>
          </div>`
          );

          $('.promo-added').show();
          $('.promo-added').find('.remove-promo').attr('aria-live', 'assertive');
          setTimeout(() => {
            $('.promo-added').find('.remove-promo').addClass('ccl-ada-focus');
            $('.promo-added').find('.remove-promo').focus();
          }, 3000);
        } else {
          $('.promo-added').append(
            `<div class="promo-applied row-${voucherCode}">
            <div class="inner-promo-applied">
              <div class="show-promo">PROMO:<span class="promo-code-text"  aria-live="assertive" role="alert" aria-label="promo ${voucherCode} applied">${voucherCode}</span>
              <a href="#" class="remove-promo" aria-label="remove applied promo ${voucherCode}" data-promocode="${voucherCode}">Remove</a>
              </div>
              <div class="discount">$0.00</div>
            </div>
            <div class="remove-error-div"></div>
          </div>`
          );

          $('.promo-added').show();
          $('.promo-added').find('.remove-promo').attr('aria-live', 'assertive');
          setTimeout(() => {
            $('.promo-added').find('.remove-promo').addClass('ccl-ada-focus');
            $('.promo-added').find('.remove-promo').focus();
          }, 3000);
        }

        $('.another-promo').show();
        gfunctions.updateCartSummary(response.orderSummary);
        gfunctions.updateProductSummary(response.orderSummary);
        this.maxCouponCount = response.maxCouponCount;
        if ($('.promo-applied').length === (this.maxCouponCount)) {
          $('.another-promo').hide();
        } else {
          $('.another-promo').show();
        }
      } else {
        $('.error-msg').html(response.message).show();
        $('body').addClass('ccl-ada-focus');
        $('#promo-id').focus();
      }
      console.log('promo code ajax success');
    }).fail((response) => {
      gfunctions.hideLoader();
      console.log('promo code ajax error');
    });
  },

  enableDeliveryCheckoutButton() {
    $('.c-order-summary').find('.btn-wrap').removeClass('d-none');
  },

  enableDeliveryPlaceOrderButton() {
    $('.c-order-summary').find('.place-order-info').removeClass('d-none');
  }
};



// WEBPACK FOOTER //
// ./src/app/components/c-order-summary/order-summary.js